<div class="inner-content">
  <div class="div_content">
    <h2 class="title">{{'Select Drivers' | translate}}</h2>
  </div>
  <div class="content">
    <p class="empty ion-text-center" *ngIf="!drivers?.length">{{'No Active Driver Found' | translate}}</p>
    <ion-list>
      <ion-radio-group [(ngModel)]="selectedDriver">
        <ion-list-header>
          <ion-label>{{'Drivers' | translate}}</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let driver of drivers; trackBy: trackById" lines="none">
          <ion-avatar slot="start">
            <img [src]="getProfilePic(driver)" alt="{{driver.fullname}}" />
          </ion-avatar>
          <ion-label
            >{{driver.fullname}}<br />
            <p class="driver_status">
              <strong>{{'Status' | translate}}:</strong>
              <ion-icon
                aria-hidden="true"
                [name]="driver.current === 'busy' ? 'time-outline' : 'checkmark-circle-outline'"
              ></ion-icon>
              {{driver.current | translate}}
            </p>
            <p><strong>{{'Distance' | translate}}:</strong> {{driver.distance}}Km</p>
          </ion-label>
          <ion-radio [value]="driver.id"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
  </div>
  <div class="div_btn">
    <ion-button class="btn_cancel" (click)="close()" fill="outline"> {{'Cancel' | translate}} </ion-button>
    <ion-button class="btn_confirm" (click)="select()"> {{'Select' | translate}} </ion-button>
  </div>
</div>
